<template>
  <BaseLightArtworkCard @click="play">
    <!-- Name -->
    <template #title>
      <router-link :to="{name: 'beat', params: {beat: beat.alias}}">{{beat.name}}</router-link>
    </template>

    <!-- Genre -->
    <template #subtitle>
      {{ beat.genre.name }}
    </template>

    <!-- Artwork -->
    <template #artwork>
      <img :src="beat.image(imageSize)" :alt="beat.name" />
    </template>

    <!-- Play Button -->
    <template #playButton>
      <PlayButton :playing="isPlaying" />
    </template>

    <!-- Buy Button -->
    <template #buyButton>
      <BuyButton :item="beat"
                 variant="overImage"
                 v-if="beat.minPrice() > 0"></BuyButton>
    </template>
  </BaseLightArtworkCard>
</template>
<script>
import BaseLightArtworkCard from "./base/BaseLightArtworkCard";
import BuyButton from "../shared/buy-button";
import PlayButton from "../base/base-play";

export default {
  components: { BuyButton, BaseLightArtworkCard, PlayButton },
  props: {
    beat: {
      type: Object,
      required: true
    },
    imageSize: {
      type: Number,
      default: 100
    }
  },
  computed: {
    playerActive() {
      return this.$store.state.player.playing
    },
    playlistManager() {
      return this.$store.state.playlistManager
    },
    isPlaying() {
      return (this.playlistManager.isPlaying(this.beat) && this.playerActive)
    },
    isPaused() {
      return (this.playlistManager.isPlaying(this.beat) && !this.playerActive)
    },
  },
  methods: {
    play(){
      if(this.isPlaying){
        this.beat.pause()
      }else{
        this.beat.play()
      }
    }
  }
};
</script>
